import React from 'react'

const BackgroundBlur = ({ visible }) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(15px)',
        transition: 'opacity 0.3s ease-in-out, backdrop-filter 0.3s ease-in-out',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        willChange: 'opacity, backdrop-filter'
      }}
    />
  )
}

export default BackgroundBlur
